import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

import { OrderProfile } from '../types';

export type State = {
  panelOpen: boolean;
  orderProfile: OrderProfile | null;
};

const INITIAL_STATE: State = {
  panelOpen: false,
  orderProfile: null,
};

type Actions = {
  setPanelOpen(open: boolean): void;
  setOrderProfile(orderProfile: OrderProfile | null): void;
  reset(): void;
};

export const useOrderProfileStore = create<State & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setPanelOpen(value) {
        set(
          {
            panelOpen: value,
          },
          undefined,
          {
            type: 'setPanelOpen',
          },
        );
      },

      setOrderProfile(orderProfile) {
        set(
          {
            orderProfile,
          },
          undefined,
          {
            type: 'setOrderProfile',
          },
        );
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'orderProfileStore', ...DEVTOOLS_OPTIONS },
  ),
);
